
























import { defineComponent } from "@vue/composition-api";
import { gtagTrackEventScrile } from "@/lib/analytics";
import { $t } from "@/lib/i18nHelpers";
import { loginEmail } from "@/lib/loginHelpers";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import LoginContainer from "@/components/LoginContainer";

export default defineComponent({
  name: "LoginComponent",
  components: { BaseForm, BaseButton, LoginContainer },
  props: {
    safe: { type: Boolean, default: false },
  },
  data() {
    return {
      values: {} as FormValues,
      loading: false,
      errorText: "",
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "email",
          label: $t("Email"),
          autocomplete: "email",
          type: "email",
          invalidField: !!this.errorText,
        },
        {
          name: "password",
          label: $t("Password"),
          autocomplete: "current-password",
          type: "password",
          invalidField: !!this.errorText,
        },
      ];
    },
  },
  methods: {
    onInput(values: FormValues) {
      this.values = values;
      this.errorText = "";
    },
    async submit() {
      try {
        this.loading = true;
        const response = await loginEmail(this.values.email, this.values.password, this.safe);
        this.$emit("login");
        gtagTrackEventScrile("user_role_dimension", { user_role: response.user.role });
      } catch (e) {
        this.errorText = $t("Incorrect password or email");
      } finally {
        this.loading = false;
      }
    },
  },
});
